module.exports = "<input\n  *ngFor=\"let field of fields; let index = index; trackBy: trackByIndex\"\n  class=\"form-control fs-14 mb-3\"\n  [placeholder]=\"placeholder\"\n  (blur)=\"changeField(index, $event.target.value)\"\n  [value]=\"field\"\n>\n<div class=\"add-address form-control d-flex align-items-center justify-content-center\" (click)=\"addNewEmptyField()\">\n  <i class=\"svg-container\" inlineSVG=\"/assets/images/action-icons/plus.svg\"></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/multiple-fields/multiple-fields.component.html
// module id = ./src/app/shared/multiple-fields/multiple-fields.component.html
// module chunks = main